// Turns the `defaults` of an event type (see EventType::defaults() in the API) into the short
// texts shown in the event types table of the docs.
const HORSE_CLASS_LABELS = { 1: 'Futurity', 2: 'Maiden', 3: 'Novice', 4: 'Open', 5: 'Any' }
const SEX_LABELS = { 1: 'Male', 2: 'Female' }

function ageText(min, max) {
  if (min > 0 && max > 0) return `Age ${min}-${max}`
  if (min > 0) return `Age ${min}+`
  if (max > 0) return `Age up to ${max}`
  return null
}

export function roundsText(defaults) {
  if (defaults.has_rounds === false) return '-'
  return defaults.rounds > 0 ? String(defaults.rounds) : 'Set manually'
}

export function ridersText(defaults) {
  const parts = [
    ageText(defaults.riders_min_age, defaults.riders_max_age),
    SEX_LABELS[defaults.riders_sex] || null,
    defaults.riders_maiden ? 'Maiden riders only' : null
  ].filter(Boolean)

  return parts.length ? parts.join(', ') : 'No restrictions'
}

export function horsesText(defaults) {
  if (defaults.has_horse_restrictions === false) return '-'

  const classes = defaults.horse_classes || []
  const parts = [
    ageText(defaults.horses_min_age, defaults.horses_max_age),
    classes.includes(5) || !classes.length
      ? 'Any class'
      : classes.map(id => HORSE_CLASS_LABELS[id]).filter(Boolean).join(', ')
  ].filter(Boolean)

  return parts.join(', ')
}



// WEBPACK FOOTER //
// ./src/docs/eventTypeDefaults.js